export default axios => ({
  signIn (payload) {
    return axios.post('auth/signin', payload)
  },
  signUp (payload) {
    return axios.post('auth/signup', payload)
  },
  signUpVerify (payload) {
    return axios.post('auth/verify', payload)
  },
  resetPassword (payload) {
    return axios.post('auth/reset', payload)
  },
  resetPasswordComplete (payload) {
    return axios.post('auth/reset/complete', payload)
  },
  signOut () {
    // return axios.post('auth/signout')
  },
  refreshToken (payload) {
    return axios.get('auth/refresh', payload)
  },
  profile (payload) {
    return axios.get('profile', payload)
  }
})
